import React from "react";
import { $t } from '@/modules/i18n';

class Timeline extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="timeline">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.timeline)}</h2>
          </div>
          {
            msg.timelineData.map((item, index) => {
              return (
                <div className="col" key={index}>
                  <p className="date">{$t(item.date)}</p>
                  <p className="content">{$t(item.desc)}</p>
                </div>
              )
            })
          }
          <div className="note">
            <p>{$t(msg.timelineNote)}</p>
          </div>
        </div>
      </section>
    );
  }
}

export default Timeline;